import { PageHeader } from "@/components/PageHeader";
import { ProjectsSection } from "@/components/ProjectsSection";

// Projects lists the GitHub repositories bee is configured to watch
// and toggles the per-repo review/babysit workflow flags. The actual
// CRUD UI lives in ProjectsSection; this page just frames it with
// the standard PageHeader.
export default function Projects() {
  return (
    <>
      <PageHeader
        title="Projects"
        description="Repositories bee watches, plus per-repo workflow toggles."
      />
      <ProjectsSection />
    </>
  );
}
